import React, { useState } from "react";
import tabOneImage from "../../assets/workforce-activity-tracking.svg";
import tabTwoImage from "../../assets/safety-compliance-monitoring.svg";
import tabThreeImage from "../../assets/self-checkout-vision-systems.svg"
import tabFourImage from "../../assets/license-plate-and-face-recognition.svg"
import "./fourtab.css";
import dot from "../../assets/dots.svg";

const AgentTabSwitchSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Detect",
      content: {
        heading: "Proactive Monitoring with AI Agents",
        desc: "AI agents continuously observe logs, metrics, and dependencies across environments, detecting anomalies before they escalate into outages. This proactive approach ensures early warning signals are captured, enabling faster responses, reduced downtime, and improved operational reliability across complex infrastructures.",
        image: tabOneImage,
      },
    },
    {
      title: "Diagnose",
      content: {
        heading: "Root Cause Analysis with Dependency Graphs",
        desc: "AgentSRE pinpoints the true source of incidents using service dependency graphs and telemetry context. This eliminates guesswork, accelerates RCA, and helps teams understand cross-service impacts instantly.",
        image: tabTwoImage,
      },
    },
    {
      title: "Remediate",
      content: {
        heading: "Automated Workflows for Fast Recovery",
        desc: "Predefined playbooks and adaptive automation allow AgentSRE to resolve incidents in real time. From restarting pods to rolling back configs, issues are remediated before they impact customers.",
        image: tabThreeImage,
      },
    },
    {
      title: "Optimize",
      content: {
        heading: "Continuous Feedback for Cost and Performance",
        desc: "AgentSRE enforces tagging, budget compliance, and performance efficiency through feedback loops. This ensures reliability improvements also drive lower costs and sustainable operations.",
        image: tabFourImage,
      },
    },
  ];

  return (
    <section className="agent-tab-switch-section" id="platform">
      <div className="container">
        {/* Section Heading */}
        <div className="tab-switch-section-heading">
          <div className="section-tag">
            <img src={dot} alt="dot-image" />
            <p className="gradient-border-heading">How It Works</p>
          </div>
          <h2>From Alert to Resolution - Automated Every Step</h2>
          <p>
            AgentSRE transforms alerts into action: intelligent AI agents identify issues, analyze causes, fix problems, and improve system efficiency automatically
          </p>

        </div>

        {/* Tabs */}
        <div className="wrapper-agent-tab-switch">
          <div className="agent-tab-switch-header">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`tab-btn ${activeTab === index ? "active" : ""}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.title}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? "active" : ""}`}
          >
            <div className="row tab-content-wrapper">
              <div className="col-12 col-md-6 col-sm-6 col-lg-6">
                <div className="tab-text-content">
                  <h3>{tab.content.heading}</h3>
                  <p>{tab.content.desc}</p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-sm-6 col-lg-6">
                <div className="tab-image-content text-center">
                  <img
                    src={tab.content.image}
                    alt={tab.content.heading}
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AgentTabSwitchSection;
